// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "spa/css/" + {"204":"filtered-job-search","637":"job-search"}[chunkId] + "." + {"204":"55ca04e9","637":"333c2546"}[chunkId] + ".css";
};